import * as API from "axios/axios";

export const firmwareService = {
  upload: (data) => API.post("/api/firmware/upload", data, {}),
};
